/**
 * Reine Query-Planung fuer den Spielekatalog. Ohne Supabase-Abhaengigkeit,
 * damit die Regeln testbar sind, die wirklich wichtig sind:
 * Keyset-Pagination, Obergrenze, Sortierung.
 */
export const MAX_LIMIT = 50;
export function encodeGameCursor(cursor) {
    return Buffer.from(JSON.stringify([cursor.title, cursor.id]), 'utf8').toString('base64url');
}
export function decodeGameCursor(raw) {
    if (!raw)
        return null;
    try {
        const parsed = JSON.parse(Buffer.from(raw, 'base64url').toString('utf8'));
        if (!Array.isArray(parsed) || parsed.length !== 2)
            return null;
        const [title, id] = parsed;
        if (typeof title !== 'string' || typeof id !== 'string')
            return null;
        return { title, id };
    }
    catch {
        return null;
    }
}
export function escapePostgrestValue(value) {
    // PostgREST trennt Filterlisten mit Komma und Klammern.
    return `"${value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
}
export function buildGameQueryPlan(request) {
    const limit = Math.min(Math.max(request.limit, 1), MAX_LIMIT);
    const cursor = decodeGameCursor(request.cursor);
    const search = request.query.trim() === '' ? null : request.query.trim();
    return {
        limit,
        fetchLimit: limit + 1,
        search,
        platform: request.platform ?? null,
        supportState: request.supportState ?? null,
        cursor,
        keysetOr: cursor
            ? `title.gt.${escapePostgrestValue(cursor.title)},` +
                `and(title.eq.${escapePostgrestValue(cursor.title)},id.gt.${cursor.id})`
            : null,
    };
}
/** Teilt die geholten Zeilen in Seite + naechsten Cursor. */
export function sliceToPage(rows, limit) {
    const hasMore = rows.length > limit;
    const items = hasMore ? rows.slice(0, limit) : rows;
    const last = items.at(-1);
    return {
        items,
        hasMore,
        nextCursor: hasMore && last ? encodeGameCursor({ title: last.title, id: last.id }) : null,
    };
}
//# sourceMappingURL=game-query.js.map